module.exports = __webpack_public_path__ + "media/bootstrap-icons/phone-landscape-7b883ad7.svg";